var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("jet-form-section", {
        on: { submitted: _vm.createApiToken },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(" Create API Token ")]
            },
            proxy: true,
          },
          {
            key: "description",
            fn: function () {
              return [
                _vm._v(
                  "\n      API tokens allow third-party services to authenticate with our\n      application on your behalf.\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "form",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "col-span-6 sm:col-span-4" },
                  [
                    _c("jet-label", { attrs: { for: "name", value: "Name" } }),
                    _vm._v(" "),
                    _c("jet-input", {
                      staticClass: "mt-1 block w-full",
                      attrs: { id: "name", type: "text", autofocus: "" },
                      model: {
                        value: _vm.createApiTokenForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.createApiTokenForm, "name", $$v)
                        },
                        expression: "createApiTokenForm.name",
                      },
                    }),
                    _vm._v(" "),
                    _c("jet-input-error", {
                      staticClass: "mt-2",
                      attrs: { message: _vm.createApiTokenForm.error("name") },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.availablePermissions.length > 0
                  ? _c(
                      "div",
                      { staticClass: "col-span-6" },
                      [
                        _c("jet-label", {
                          attrs: { for: "permissions", value: "Permissions" },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mt-2 grid grid-cols-1 md:grid-cols-2 gap-4",
                          },
                          _vm._l(
                            _vm.availablePermissions,
                            function (permission) {
                              return _c("div", { key: permission }, [
                                _c(
                                  "label",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.createApiTokenForm.permissions,
                                          expression:
                                            "createApiTokenForm.permissions",
                                        },
                                      ],
                                      staticClass: "form-checkbox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        value: permission,
                                        checked: Array.isArray(
                                          _vm.createApiTokenForm.permissions
                                        )
                                          ? _vm._i(
                                              _vm.createApiTokenForm
                                                .permissions,
                                              permission
                                            ) > -1
                                          : _vm.createApiTokenForm.permissions,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.createApiTokenForm
                                                .permissions,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = permission,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.createApiTokenForm,
                                                  "permissions",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.createApiTokenForm,
                                                  "permissions",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.createApiTokenForm,
                                              "permissions",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-2 text-sm text-gray-600",
                                      },
                                      [_vm._v(_vm._s(permission))]
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "jet-action-message",
                  {
                    staticClass: "mr-3",
                    attrs: { on: _vm.createApiTokenForm.recentlySuccessful },
                  },
                  [_vm._v("\n        Created.\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "jet-button",
                  {
                    class: { "opacity-25": _vm.createApiTokenForm.processing },
                    attrs: { disabled: _vm.createApiTokenForm.processing },
                  },
                  [_vm._v("\n        Create\n      ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.tokens.length > 0
        ? _c(
            "div",
            [
              _c("jet-section-border"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-10 sm:mt-0" },
                [
                  _c("jet-action-section", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v(" Manage API Tokens ")]
                          },
                          proxy: true,
                        },
                        {
                          key: "description",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n          You may delete any of your existing tokens if they are no longer\n          needed.\n        "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "space-y-6" },
                                _vm._l(_vm.tokens, function (token) {
                                  return _c(
                                    "div",
                                    {
                                      key: token,
                                      staticClass:
                                        "flex items-center justify-between",
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(token.name) +
                                            "\n              "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex items-center" },
                                        [
                                          token.last_used_at
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-sm text-gray-400",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Last used\n                  " +
                                                      _vm._s(
                                                        _vm.fromNow(
                                                          token.last_used_at
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.availablePermissions.length > 0
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "cursor-pointer ml-6 text-sm text-gray-400 underline focus:outline-none",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.manageApiTokenPermissions(
                                                        token
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Permissions\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "cursor-pointer ml-6 text-sm text-red-500 focus:outline-none",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmApiTokenDeletion(
                                                    token
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Delete\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1449311930
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("jet-dialog-modal", {
        attrs: { show: _vm.displayingToken },
        on: {
          close: function ($event) {
            _vm.displayingToken = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(" API Token ")]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", [
                  _vm._v(
                    "\n        Please copy your new API token. For your security, it won't be shown\n        again.\n      "
                  ),
                ]),
                _vm._v(" "),
                _vm.$page.props.jetstream.flash.token
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mt-4 bg-gray-100 px-4 py-2 rounded font-mono text-sm text-gray-500",
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$page.props.jetstream.flash.token) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "jet-secondary-button",
                  {
                    nativeOn: {
                      click: function ($event) {
                        _vm.displayingToken = false
                      },
                    },
                  },
                  [_vm._v("\n        Close\n      ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("jet-dialog-modal", {
        attrs: { show: _vm.managingPermissionsFor },
        on: {
          close: function ($event) {
            _vm.managingPermissionsFor = null
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(" API Token Permissions ")]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4" },
                  _vm._l(_vm.availablePermissions, function (permission) {
                    return _c("div", { key: permission }, [
                      _c("label", { staticClass: "flex items-center" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.updateApiTokenForm.permissions,
                              expression: "updateApiTokenForm.permissions",
                            },
                          ],
                          staticClass: "form-checkbox",
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: permission,
                            checked: Array.isArray(
                              _vm.updateApiTokenForm.permissions
                            )
                              ? _vm._i(
                                  _vm.updateApiTokenForm.permissions,
                                  permission
                                ) > -1
                              : _vm.updateApiTokenForm.permissions,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.updateApiTokenForm.permissions,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = permission,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.updateApiTokenForm,
                                      "permissions",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.updateApiTokenForm,
                                      "permissions",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.updateApiTokenForm,
                                  "permissions",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "ml-2 text-sm text-gray-600" },
                          [_vm._v(_vm._s(permission))]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "jet-secondary-button",
                  {
                    nativeOn: {
                      click: function ($event) {
                        _vm.managingPermissionsFor = null
                      },
                    },
                  },
                  [_vm._v("\n        Nevermind\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "jet-button",
                  {
                    staticClass: "ml-2",
                    class: { "opacity-25": _vm.updateApiTokenForm.processing },
                    attrs: { disabled: _vm.updateApiTokenForm.processing },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.updateApiToken.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n        Save\n      ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("jet-confirmation-modal", {
        attrs: { show: _vm.apiTokenBeingDeleted },
        on: {
          close: function ($event) {
            _vm.apiTokenBeingDeleted = null
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(" Delete API Token ")]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _vm._v(
                  "\n      Are you sure you would like to delete this API token?\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "jet-secondary-button",
                  {
                    nativeOn: {
                      click: function ($event) {
                        _vm.apiTokenBeingDeleted = null
                      },
                    },
                  },
                  [_vm._v("\n        Nevermind\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "jet-danger-button",
                  {
                    staticClass: "ml-2",
                    class: { "opacity-25": _vm.deleteApiTokenForm.processing },
                    attrs: { disabled: _vm.deleteApiTokenForm.processing },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.deleteApiToken.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n        Delete\n      ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }